import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import ExperienceSection from "../components/ExperienceSection";
import Planos from "../components/Planos";
import FourItems from "../components/FourItems";
import ShopSection from "../components/ShopSection";
import MapSection from "../components/Map";

const HomePage = () => {
  return (
    <div className="homepage">
      <Header />
      <Hero />
      <ExperienceSection />
      <Planos/>
      <FourItems/>
      <ShopSection/>
      <MapSection/>
      <Footer />
    </div>
  );
};

export default HomePage;
